var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalHoldExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.529,
    x2: 33.6,
    y1: -3905.471,
    y2: -3900.4,
    gradientTransform: "matrix(1 0 0 -1 0 -3890)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      fillOpacity: 1
    },
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17z",
    fill: "#50e6ff",
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      fillOpacity: 1
    },
    d: "M28 5v9a2 2 0 0 0 2 2h9z",
    fill: "url(#a)",
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M35.898 18.514v25a2 2 0 0 1-2 2h-26a2 2 0 0 1-2-2v-34a2 2 0 0 1 2-2h17Z",
    style: {
      fill: "#e0e0e0",
      fillOpacity: 1
    },
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M24.898 7.514v9a2 2 0 0 0 2 2h9z",
    style: {
      fill: "#c7c7c7",
      fillOpacity: 1
    },
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M32.11 20.996v25a2 2 0 0 1-2 2h-26a2 2 0 0 1-2-2v-34a2 2 0 0 1 2-2h17Z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    },
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M21.11 9.996v9a2 2 0 0 0 2 2h9z",
    style: {
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "translate(3.971 -2.309)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35 17.497h8v11h-8z",
    style: {
      opacity: 1,
      fill: "#9e1212",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e1212",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m20.35 38.599-11-13.102h22Zm-4-27.102h8v4h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M16.41 11.417h8v8.363h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M16.41 17.417h8v11h-8z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#892ca0",
      fillOpacity: 1,
      strokeWidth: 3.7094,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m20.41 38.519-11-13.102h22Z",
    transform: "matrix(.65267 .65269 .66512 -.66515 7.626 14.31)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalHoldExport);
export default __webpack_public_path__ + "static/media/legalHoldExport.7523e6df2310f6e9ddfb74b898cb367a.svg";
export { ForwardRef as ReactComponent };